import React from 'react';
import { motion } from 'framer-motion';
export function OfferStack() {
  const items = [{
    title: 'Ebook Principal: Edutainment OS',
    value: '$147',
    desc: 'El blueprint maestro para la estética Ted-Ed con IA.',
    img: 'https://cdn.magicpatterns.com/uploads/uFg6KoPXaxtguq7Qpzbzoa/MK_1.png'
  }, {
    title: 'Bonus 1: 50 Frameworks de Guiones Magnéticos',
    value: '$97',
    desc: 'Estructuras probadas para que tu mensaje nunca sea ignorado.',
    img: 'https://cdn.magicpatterns.com/uploads/qk8jTd2oRpfQKWBHEn69f4/BN_1.png'
  }, {
    title: 'Bonus 2: Toolkit de Visuales IA de Élite',
    value: '$67',
    desc: 'Prompts quirúrgicos para generar animaciones premium en segundos.',
    img: 'https://cdn.magicpatterns.com/uploads/x7uUC2j3zRxwL78w178n3h/BN-2.png'
  }, {
    title: "Bonus 3: Checklist de 'Reten-Master' de 10 Puntos",
    value: '$27',
    desc: 'Tu filtro de calidad antes de cada publicación.',
    img: 'https://cdn.magicpatterns.com/uploads/6855uzWcStuob6XT2cehB9/BN-3.png'
  }, {
    title: "Bonus 4: Plan de Acción 'Tu Primer Video en 24h'",
    value: '$17',
    desc: 'La ruta directa para tu primera victoria visual.',
    img: 'https://cdn.magicpatterns.com/uploads/kscqVvXAiPjeTMkMbfXRcr/BN_4.png'
  }];
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-800 border-y border-white/5" data-id="element-82">
      <div className="max-w-5xl mx-auto" data-id="element-83">
        <div className="text-center mb-8 md:mb-16" data-id="element-84">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-3 md:mb-4" data-id="element-85">
            El Edutainment OS Value Stack
          </h2>
          <p className="text-gray-400 text-sm md:text-base" data-id="element-86">
            Al aceptar el compromiso hoy, obtienes acceso total a:
          </p>
        </div>

        <div className="space-y-6 md:space-y-12" data-id="element-87">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-5 md:gap-8 bg-navy-900/50 p-4 md:p-6 rounded-2xl border border-white/5`} data-id="element-88">
              <div className="w-full md:w-1/2" data-id="element-89">
                <img src={item.img} alt={item.title} className="w-full h-auto rounded-lg shadow-lg" data-id="element-90" />
              </div>
              <div className={`w-full md:w-1/2 flex flex-col justify-center ${index % 2 === 0 ? 'md:pl-8' : 'md:pr-8'}`} data-id="element-91">
                <div className="inline-block bg-gold-500/10 text-gold-500 px-3 py-1 rounded-full text-xs md:text-sm font-medium mb-3 md:mb-4 w-fit border border-gold-500/20" data-id="element-92">
                  Valor:{' '}
                  <span className="line-through opacity-70" data-id="element-93">{item.value}</span>
                </div>
                <h3 className="text-xl md:text-2xl font-serif font-bold mb-2 md:mb-3" data-id="element-94">
                  {item.title}
                </h3>
                <p className="text-gray-300 font-light text-base md:text-lg" data-id="element-95">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-10 md:mt-16 text-center bg-navy-900 p-6 md:p-8 rounded-2xl border border-gold-500/30" data-id="element-96">
          <p className="text-base md:text-xl text-gray-400 mb-2 uppercase tracking-widest" data-id="element-97">
            Valor Total
          </p>
          <p className="text-3xl md:text-5xl font-serif font-black text-white line-through decoration-red-500/50 decoration-4" data-id="element-98">
            $355.00
          </p>
        </motion.div>
      </div>
    </section>;
}